import api from '../../utils/api'

const API_BASE_URL = "/geo/GEOPost";

const GEOPostService = {
    async findAll(): Promise<any> {
        const response = await api.get(`${API_BASE_URL}/find-all`);
        return response.data;
    },

    async getItemById(postId: string): Promise<any> {
        const response = await api.get(`${API_BASE_URL}/find-one/${postId}`);
        return response.data;
    },

    async create(item: any): Promise<any> {
        const response = await api.post(`${API_BASE_URL}/create`, item);
        return response.data;
    },

    async update(postId: string, item: any): Promise<any> {
        const response = await api.put(`${API_BASE_URL}/update/${postId}`, item);
        return response.data;
    },

    async delete(postId: string): Promise<any> {
        const response = await api.delete(`${API_BASE_URL}/delete/${postId}`);
        return response.data;
    },

    async getDropdownByStateCode(stateCode: string): Promise<any> {
      const response = await api.get(`${API_BASE_URL}/get-dropdown-by-state/${stateCode}`);
      return response.data;
    },
};

export default GEOPostService;